import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Filter, Main } from 'Containers';
import { LoadingPage } from 'Components';
import {
  ItemEnum,
  FilterEnum,
  ItemStorageLocationEnum,
} from 'Common/FieldEnum';
import { ITEM_STORAGE_LOCATION_FORM_NAME } from 'Common/FormEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { submitForm, resetForm } from 'State/forms/actions';
import {
  saveItemStorageLocation,
  clearItemSubmitError,
  getSiteStorageLocByItem,
  getStorageLocation,
} from '../state/itemStorageLocation/actions';
import { getStorageLocationForCurrentSite } from 'State/filters/actions';
import { SetStorageLocationContainer } from '../containers/SetStorageLocation';
import { TypeOfDropDownEnum } from 'Common/Constants/Enumeration/CommonEnum';

class ItemStorageLocation extends Component {
  static path = '/itemmaintenance/storagelocation/:id';

  componentDidMount() {
    const { id } = this.props.match.params;

    const {
      getStorageLocationForCurrentSite,
      getSiteStorageLocByItem,
      getStorageLocation,
    } = this.props;
    if (+id) {
      getSiteStorageLocByItem(id);
    }
    getStorageLocationForCurrentSite(TypeOfDropDownEnum.UnassignedOnly);
    getStorageLocation(TypeOfDropDownEnum.Nothing);
  }

  onSaveClick = () => {
    this.props.submitForm(ITEM_STORAGE_LOCATION_FORM_NAME);
  };

  onResetClick = () => {
    this.props.resetForm(ITEM_STORAGE_LOCATION_FORM_NAME);
  };
  getMainProps = () => {
    const { submitting, isReadOnly, formHasErrors } = this.props;

    return {
      toolbox: {
        backButtonProps: {
          shown: true,
          path: '/itemmaintenance',
        },
        rightButtons: [
          {
            content: 'Reset',
            disabled: submitting || isReadOnly || formHasErrors,
            onClick: this.onResetClick,
          },
          {
            content: 'Save',
            disabled: submitting || isReadOnly || formHasErrors,
            onClick: this.onSaveClick,
          },
        ],
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps) {
    const { clearItemSubmitError } = this.props;
    if (
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'fetchingItemStorageLocationError') ||
      errorToast(this.props, prevProps, 'gridStorageLocationDataError')
    ) {
      clearItemSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Item Storage Location assignment has been saved',
        true
      );
      clearItemSubmitError();
    }
  }

  resetScroll = () => this.props.scrollMainTo(0, 0);

  handleItemDetailSubmit = values => {
    const { id } = this.props.match.params;
    const data = [];
    _.each(values.ItemStorageLocationInfo[0], (StoreId, SiteId) => {
      StoreId &&
        data.push({
          SiteId,
          StoreId,
        });
    });
    values.ItemStorageLocationInfo &&
      values.ItemStorageLocationInfo.length &&
      this.props.saveItemStorageLocation(
        {
          ItemId: id,
          SiteStorageLocationMapping: data,
        },
        this.resetScroll
      );
  };
  getInitialValues = () => {
    const { itemStorageLocationData } = this.props;
    let initialValues = {
      [ItemStorageLocationEnum.ItemStorageLocationInfo]: [],
      [FilterEnum.GroupId_Location]: -1,
      [ItemEnum.ItemCode]: '',
      [ItemEnum.ItemDescription]: '',
    };
    if (itemStorageLocationData && itemStorageLocationData.SiteStorageLocList) {
      const assignedStorage = {};
      itemStorageLocationData &&
        itemStorageLocationData.SiteStorageLocList &&
        itemStorageLocationData.SiteStorageLocList.length &&
        itemStorageLocationData.SiteStorageLocList.forEach(store => {
          if (+store[ItemStorageLocationEnum.StoreId]) {
            assignedStorage[store[ItemStorageLocationEnum.SiteId]] =
              store[ItemStorageLocationEnum.StoreId];
          }
        });
      const storageInfo = Object.keys(assignedStorage).length
        ? [assignedStorage]
        : [];
      initialValues = {
        [ItemStorageLocationEnum.ItemStorageLocationInfo]: storageInfo,
        [FilterEnum.GroupId_Location]: -1,
        [ItemEnum.ItemCode]: itemStorageLocationData.ItemCode,
        [ItemEnum.ItemDescription]: itemStorageLocationData.ItemDescription,
      };
    }
    return initialValues;
  };
  render() {
    const { submitting, fetchingItemStorageLocation } = this.props;
    const initialValues = this.getInitialValues();

    return (
      <Fragment>
        {(submitting || fetchingItemStorageLocation) && <LoadingPage />}
        <Filter title={'Item Maintenance | Storage Location'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <SetStorageLocationContainer
            onSubmit={this.handleItemDetailSubmit}
            initialValues={initialValues}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { itemStorageLocation } = state.ItemMaintenanceState;
  const { filters } = state.CommonState;
  const {
    submitting,
    submitted,
    submitError,
    fetchingItemStorageLocationError,
    itemStorageLocationData,
    fetchingItemStorageLocation,
    gridStorageLocationDataError,
  } = itemStorageLocation;
  return {
    storageLocationDataError: filters.storageLocationDataError,
    submitting,
    submitted,
    submitError,
    fetchingItemStorageLocationError,
    itemStorageLocationData,
    fetchingItemStorageLocation,
    gridStorageLocationDataError,
  };
};

const mapDispatchToProps = {
  saveItemStorageLocation,
  submitForm,
  clearItemSubmitError,
  resetForm,
  getSiteStorageLocByItem,
  getStorageLocationForCurrentSite,
  getStorageLocation,
};
export const ItemStorageLocationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemStorageLocation);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/subpages/ItemStorageLocation.js